var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.3 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8ab5d;}.cls-2{fill:#ffe779;}.cls-3{fill:#6dafa7;}.cls-4{fill:#f4c2c9;}.cls-5{fill:#22272e;}.cls-6{fill:none;stroke:#22272e;stroke-linecap:round;stroke-linejoin:round;stroke-width:6.51px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.15,309c-83.58,81-187.43,97-225.06,41.25C104.8,301,136.28,213.45,204.31,150.13c66.94-62.24,155.22-87.93,203-55C461.21,132,445.29,229.37,363.15,309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.21,296.67c-83.58,81.05-187.43,97-225.06,41.25-33.29-49.21-1.81-136.77,66.22-200.1,66.94-62.23,155.22-87.92,203-55C449.63,120.09,433.35,217.43,351.21,296.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.11,261.57c-50.29,48.13-113.25,60.07-138.58,27.86-23.16-29.67-4.7-85.75,39.44-127,43.78-40.89,100.59-56.45,129.9-33.29C378.35,153.75,365.69,213.81,316.11,261.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.91,229.37c-19.9,18.81-45.23,24.24-56.08,12.3-10.5-11.58-3.62-35.1,15.19-52.83s43.06-23.52,54.64-13C309.6,186.31,303.81,210.55,283.91,229.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.46,107.79h0a18.91,18.91,0,0,1-26.78-1.08L64.27,24.57a10.55,10.55,0,0,1,1.09-14.11h0a10.52,10.52,0,0,1,14.11,0L156.18,81A18.28,18.28,0,0,1,155.46,107.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.11,40.13,58.49,43c-5.79.73-8,8-3.62,11.58h0A90.84,90.84,0,0,0,99.74,76l10.49,1.81a1.42,1.42,0,0,0,1.45-2.17L85.62,42.66A7.55,7.55,0,0,0,79.11,40.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.31,26.38,99,6.12A6.72,6.72,0,0,1,111,3.58h0A89,89,0,0,1,128.68,49.9l.73,10.49a1.38,1.38,0,0,1-2.18,1.09L96.48,33.25C94.31,31.08,93.58,28.55,94.31,26.38Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 152.56,
    y1: 104.54,
    x2: 173.19,
    y2: 126.61
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrices);
export default __webpack_public_path__ + "static/media/prices.c66073d7f042bb3dd5c3d5773866ceb7.svg";
export { ForwardRef as ReactComponent };